// Modules
import log from './log/config.json';
import metrics from './metrics/config.json';
import campaign from './campaign/config.json';
import group from './group/config.json';
import integrations from './integrations/config.json';
import entity from './entity/config.json';
import issue from './issue/config.json';
import poll from './poll/config.json';
import profile from './profile/config.json';
import recipient from './recipient/config.json';

const modulesConfigs = [
	log,
	metrics,
	campaign,
	group,
	integrations,
	entity,
	issue,
	poll,
	profile,
	recipient,
];

const menuOrder = [
	'menuGeneral',
	'menuEngagement',
	'menuMessages',
	'menuSegmentation',
	'menuLog',
	'menuConfig',
];

export default {
	modulesConfigs,
	menuOrder,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/config.js